import { c as _c } from "react/compiler-runtime";
import { useTweetSummaryData } from './hook/useTweetSummaryData';
import { useTweetSummarySections } from './hook/useTweetSummarySections';
import type { UseTweetSummaryParameters, UseTweetSummaryResult } from './types';
export function useTweetSummary(parameters) {
  const $ = _c(48);
  const {
    state,
    actions,
    settings,
    metadata
  } = useTweetSummaryData(parameters);
  let t0;
  if ($[0] !== parameters.inlineTweetUrls || $[1] !== parameters.metrics || $[2] !== parameters.tweet || $[3] !== state.explanationState || $[4] !== state.summaryState) {
    t0 = {
      tweet: parameters.tweet,
      metrics: parameters.metrics,
      inlineTweetUrls: parameters.inlineTweetUrls,
      summaryState: state.summaryState,
      explanationState: state.explanationState
    };
    $[0] = parameters.inlineTweetUrls;
    $[1] = parameters.metrics;
    $[2] = parameters.tweet;
    $[3] = state.explanationState;
    $[4] = state.summaryState;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const sections = useTweetSummarySections(t0);
  let t1;
  if ($[6] !== actions.chatFromSummary || $[7] !== actions.closeSettings || $[8] !== actions.explain || $[9] !== actions.handleShowMoreVisibility || $[10] !== actions.openSettings || $[11] !== actions.runActiveMode || $[12] !== actions.submitSettings || $[13] !== actions.summarize || $[14] !== metadata.liveSearchProviderName || $[15] !== metadata.providerHandlesVideo || $[16] !== metadata.supportsSummarySearch || $[17] !== sections || $[18] !== settings.canonicalDraftModel || $[19] !== settings.draftCustomPrompt || $[20] !== settings.draftModel || $[21] !== settings.draftSummaryLengthIndex || $[22] !== settings.draftSummaryMode || $[23] !== settings.draftSummarySearchEnabled || $[24] !== settings.setDraftCustomPrompt || $[25] !== settings.setDraftModel || $[26] !== settings.setDraftSummaryLengthIndex || $[27] !== settings.setDraftSummaryMode || $[28] !== settings.setDraftSummarySearchEnabled || $[29] !== settings.setSummaryMode || $[30] !== settings.setSummarySearchEnabled || $[31] !== settings.settingsOpen || $[32] !== settings.summaryLengthIndex || $[33] !== settings.summaryMode || $[34] !== settings.summaryModel || $[35] !== settings.summarySearchEnabled || $[36] !== state.canExplain || $[37] !== state.canSummarize || $[38] !== state.explanationState || $[39] !== state.hasSummary || $[40] !== state.includeImagesInPrompt || $[41] !== state.isExplaining || $[42] !== state.isSummarizing || $[43] !== state.shouldRenderSummaryControls || $[44] !== state.showMoreVisible || $[45] !== state.summarizeButtonLabel || $[46] !== state.summaryState) {
    t1 = {
      includeImagesInPrompt: state.includeImagesInPrompt,
      summaryState: state.summaryState,
      explanationState: state.explanationState,
      isSummarizing: state.isSummarizing,
      isExplaining: state.isExplaining,
      canSummarize: state.canSummarize,
      canExplain: state.canExplain,
      shouldRenderSummaryControls: state.shouldRenderSummaryControls,
      summarizeButtonLabel: state.summarizeButtonLabel,
      summarize: actions.summarize,
      explain: actions.explain,
      settingsOpen: settings.settingsOpen,
      openSettings: actions.openSettings,
      closeSettings: actions.closeSettings,
      draftSummaryLengthIndex: settings.draftSummaryLengthIndex,
      setDraftSummaryLengthIndex: settings.setDraftSummaryLengthIndex,
      draftModel: settings.draftModel,
      setDraftModel: settings.setDraftModel,
      canonicalDraftModel: settings.canonicalDraftModel,
      draftCustomPrompt: settings.draftCustomPrompt,
      setDraftCustomPrompt: settings.setDraftCustomPrompt,
      draftSummarySearchEnabled: settings.draftSummarySearchEnabled,
      setDraftSummarySearchEnabled: settings.setDraftSummarySearchEnabled,
      supportsSummarySearch: metadata.supportsSummarySearch,
      liveSearchProviderName: metadata.liveSearchProviderName,
      providerHandlesVideo: metadata.providerHandlesVideo,
      submitSettings: actions.submitSettings,
      handleShowMoreVisibility: actions.handleShowMoreVisibility,
      showMoreVisible: state.showMoreVisible,
      hasSummary: state.hasSummary,
      chatFromSummary: actions.chatFromSummary,
      summaryLengthIndex: settings.summaryLengthIndex,
      summaryModel: settings.summaryModel,
      summarySearchEnabled: settings.summarySearchEnabled,
      setSummarySearchEnabled: settings.setSummarySearchEnabled,
      summaryMode: settings.summaryMode,
      setSummaryMode: settings.setSummaryMode,
      draftSummaryMode: settings.draftSummaryMode,
      setDraftSummaryMode: settings.setDraftSummaryMode,
      runActiveMode: actions.runActiveMode,
      sections
    };
    $[6] = actions.chatFromSummary;
    $[7] = actions.closeSettings;
    $[8] = actions.explain;
    $[9] = actions.handleShowMoreVisibility;
    $[10] = actions.openSettings;
    $[11] = actions.runActiveMode;
    $[12] = actions.submitSettings;
    $[13] = actions.summarize;
    $[14] = metadata.liveSearchProviderName;
    $[15] = metadata.providerHandlesVideo;
    $[16] = metadata.supportsSummarySearch;
    $[17] = sections;
    $[18] = settings.canonicalDraftModel;
    $[19] = settings.draftCustomPrompt;
    $[20] = settings.draftModel;
    $[21] = settings.draftSummaryLengthIndex;
    $[22] = settings.draftSummaryMode;
    $[23] = settings.draftSummarySearchEnabled;
    $[24] = settings.setDraftCustomPrompt;
    $[25] = settings.setDraftModel;
    $[26] = settings.setDraftSummaryLengthIndex;
    $[27] = settings.setDraftSummaryMode;
    $[28] = settings.setDraftSummarySearchEnabled;
    $[29] = settings.setSummaryMode;
    $[30] = settings.setSummarySearchEnabled;
    $[31] = settings.settingsOpen;
    $[32] = settings.summaryLengthIndex;
    $[33] = settings.summaryMode;
    $[34] = settings.summaryModel;
    $[35] = settings.summarySearchEnabled;
    $[36] = state.canExplain;
    $[37] = state.canSummarize;
    $[38] = state.explanationState;
    $[39] = state.hasSummary;
    $[40] = state.includeImagesInPrompt;
    $[41] = state.isExplaining;
    $[42] = state.isSummarizing;
    $[43] = state.shouldRenderSummaryControls;
    $[44] = state.showMoreVisible;
    $[45] = state.summarizeButtonLabel;
    $[46] = state.summaryState;
    $[47] = t1;
  } else {
    t1 = $[47];
  }
  return t1 satisfies UseTweetSummaryResult;
}
export type { SummarizeOverrides } from './types';